
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 50 50","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M50 50V31.7c0-9-1.9-15.9-12.4-15.9-5 0-8.4 2.8-9.8 5.4h-.1v-4.6h-9.9V50H28V33.5c0-4.4.8-8.6 6.2-8.6 5.3 0 5.4 5 5.4 8.8V50H50zM.8 16.6h10.4V50H.8V16.6zM6 0C2.7 0 0 2.7 0 6s2.7 6.1 6 6.1 6-2.7 6-6.1c0-3.3-2.7-6-6-6z"}})])
          )
        }
      }
    